// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3nXR2","Label":"Input_Label__2LkMx","InputElement":"Input_InputElement__EIWD5","Invalid":"Input_Invalid__23utA"};